import React, { useContext } from 'react';
import { ICommonData } from '../domain/models/ICommonData';

export const CommonDataContext = React.createContext<ICommonData>(
	{} as ICommonData,
);

export const useCommonData = () => useContext(CommonDataContext);
